module.exports = __webpack_public_path__ + "odinstatic/media/operator-info.c1ef1241.svg";